<template>
  <div class="sales">
    <HeaderPanel />
    <NavbarPanel />

    <div class="allSales">
      <div class="mySales">
        <h1>Minhas Vendas</h1>

        <div class="mySales__filter">
          <h3>Filtar vendas</h3>
          <div class="mySales__filter--options">
            <label for="">Data Inicial:</label>
            <input type="date" name="" id="" />
            <label for="">Data Final</label>
            <input type="date" name="" id="" />
            <label for="">ou</label>
            <input
              type="text"
              placeholder="Buscar por Status / Nº Pedido / Cliente / Parceiro"
            />
            <button><i class="fas fa-filter"></i> Filtrar</button>
          </div>
        </div>

        <div class="mySales__results">
          <div class="mySales__results--totalPedidos">
            <p>Total de Pedidos</p>
            <span>220</span>
          </div>

          <div class="mySales__results--ticketMedio">
            <p>Ticket Médio</p>
            <span>R$ 5.200,00</span>
          </div>

          <div class="mySales__results--receita">
            <p>Receita</p>
            <span>R$ 1.200.100,00</span>
          </div>

          <div class="mySales__results--devolucao">
            <p>Devolução</p>
            <span>R$ 5.200,00</span>
          </div>

          <div class="mySales__results--rt">
            <p>RT</p>
            <span>+ R$ 2.500,00</span>
            <span>- R$ 2.000,00</span>
            <span>= R$ 500,00</span>
          </div>
        </div>

        <div class="mySales__table" style="overflow-x: auto">
          <table>
            <thead>
              <tr>
                <th>PV</th>
                <th>Cliente</th>
                <th>Data</th>
                <th>Status</th>
                <th>Valor</th>
                <th>Desconto</th>
                <th>Parceiro</th>
                <th>Valor RT</th>
                <th>Código SAP</th>
                <th>Detalhes</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>376682</td>
                <td>LUCELIA COS...</td>
                <td>09/03/2021</td>
                <td>PENDENTE</td>
                <td>R$ 1.499,00</td>
                <td></td>
                <td>JOAO AUGUS...</td>
                <td>R$ 74,95 (5%)</td>
                <td>5678900084</td>
                <td><button>Detalhes</button></td>
              </tr>
              <tr>
                <td>376682</td>
                <td>LUCELIA COS...</td>
                <td>09/03/2021</td>
                <td>PENDENTE</td>
                <td>R$ 1.499,00</td>
                <td></td>
                <td>JOAO AUGUS...</td>
                <td>R$ 74,95 (5%)</td>
                <td>5678900084</td>
                <td><button>Detalhes</button></td>
              </tr>
              <tr>
                <td>376682</td>
                <td>LUCELIA COS...</td>
                <td>09/03/2021</td>
                <td>PENDENTE</td>
                <td>R$ 1.499,00</td>
                <td></td>
                <td>JOAO AUGUS...</td>
                <td>R$ 74,95 (5%)</td>
                <td>5678900084</td>
                <td><button>Detalhes</button></td>
              </tr>
              <tr>
                <td>376682</td>
                <td>LUCELIA COS...</td>
                <td>09/03/2021</td>
                <td>PENDENTE</td>
                <td>R$ 1.499,00</td>
                <td></td>
                <td>JOAO AUGUS...</td>
                <td>R$ 74,95 (5%)</td>
                <td>5678900084</td>
                <td><button>Detalhes</button></td>
              </tr>
              <tr>
                <td>376682</td>
                <td>LUCELIA COS...</td>
                <td>09/03/2021</td>
                <td>PENDENTE</td>
                <td>R$ 1.499,00</td>
                <td></td>
                <td>JOAO AUGUS...</td>
                <td>R$ 74,95 (5%)</td>
                <td>5678900084</td>
                <td><button>Detalhes</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPanel from "@/components/panel/HeaderPanel";
import NavbarPanel from "@/components/panel/NavbarPanel";
export default {
  components: {
    HeaderPanel,
    NavbarPanel,
  },
};
</script>

<style lang="scss" scoped>
.allSales {
  background: #ebebeb;
}
.mySales {
  max-width: 90%;
  margin: 0 auto;
  padding-top: 50px;

  h1 {
    color: #005a64;
    font-size: 1.375rem;
    padding-bottom: 30px;
  }

  &__filter {
    background: #fff;
    padding: 20px;
    border-radius: 5px;

    h3 {
      color: #005a64;
      padding-bottom: 15px;
    }

    &--options {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      @media (max-width: 440px) {
        flex-direction: column;
        align-items: flex-start;
      }

      label {
        padding: 10px;
        color: #4e4e4e;
      }

      input {
        padding: 5px 10px;
        margin: 7px;
        border: 1px solid #999999;
        border-radius: 5px;
        outline: none;
        color: #4e4e4e;

        &:nth-child(6) {
          width: 330px;
          padding: 7px;

          @media (max-width: 440px) {
            width: initial;
          }
        }
      }

      button {
        background: #005a64;
        padding: 8px 15px;
        border-radius: 5px;
        color: #fff;

        @media (max-width: 440px) {
          margin: 20px 0 0 10px;
        }
      }
    }
  }

  &__results {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    padding: 20px;
    background: #fff;
    border-radius: 5px;

    @media (max-width: 440px) {
      flex-direction: column;
    }

    &--totalPedidos,
    &--ticketMedio,
    &--receita,
    &--devolucao,
    &--rt {
      p {
        font-size: 0.938rem;
        font-weight: bold;
      }

      span {
        font-size: 1.125rem;
        font-weight: bold;
        padding-top: 10px;
      }

      &:hover {
        box-shadow: 0 4px 15px #555555;
      }
    }

    &--totalPedidos,
    &--receita,
    &--rt {
      background: #005a64;
      color: #fff;
      border-radius: 5px;
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 18%;

      @media (max-width: 440px) {
        width: 100%;
        margin: 10px 0;
      }
    }

    &--ticketMedio,
    &--devolucao {
      background: #002d32;
      color: #fff;
      border-radius: 5px;
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 18%;

      @media (max-width: 440px) {
        width: 100%;
      }
    }
  }

  &__table {
    background: #fff;
    border-radius: 5px;
    margin-top: 40px;
    padding: 20px;

    table {
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;

      thead {
        tr {
          th {
            background: #ebebeb;
            padding: 10px;
            width: 10%;
            color: #424242;
          }
        }
      }

      tbody {
        tr {
          &:nth-child(even) {
            background: #ebebeb;
          }
          td {
            padding: 10px 5px;
            text-align: center;
            color: #4e4e4e;

            button {
              background: #6fffaf;
              font-weight: bold;
              padding: 5px;
              color: #4d4d4d;
              border-radius: 5px;
              font-size: 0.75rem;
              outline: none;
            }
          }
        }
      }
    }
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #4d4d4d;
  }

  ::-webkit-scrollbar {
    height: 8px;
    background: #c5c5c5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #6fffaf;
    border-radius: 10px;
  }
}
</style>